export async function readFileAsText(file: File): Promise<string> {
  return await new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = (event) => {
      const fileContent = event.target?.result as string
      resolve(fileContent)
    }

    reader.onerror = (event) => {
      reject(event.target?.error)
    }

    reader.readAsText(file)
  })
}
